import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../App';
const LoginPage = () => {
  const {
    isDarkMode
  } = useTheme();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // No validation needed - just navigate to dashboard
    navigate('/');
  };
  return <div className={`min-h-screen w-full flex items-center justify-center ${isDarkMode ? 'bg-[#0d1117]' : 'bg-gray-50'}`} data-id="element-282">
      <div className="w-full max-w-md px-4" data-id="element-283">
        {/* Logo and Title */}
        <div className="text-center mb-8" data-id="element-284">
          <div className="flex items-center justify-center mb-4" data-id="element-285">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bSa3zYvqyPEzQAksQUw4jA/image.png" alt="BLAZE Lighthouse Logo" className="h-12" data-id="element-286" />
          </div>
          <h1 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-287">
            BLAZE Lighthouse
          </h1>
          <p className={`text-sm mt-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-288">
            Sign in to your account
          </p>
        </div>
        {/* Login Card */}
        <div className={`rounded-lg border shadow-sm ${isDarkMode ? 'bg-[#161b22] border-gray-800' : 'bg-white border-gray-200'}`} data-id="element-289">
          <div className="p-6" data-id="element-290">
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-291">
              {/* Username Field */}
              <div className="space-y-2" data-id="element-292">
                <label htmlFor="username" className={`text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${isDarkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-293">
                  Username
                </label>
                <input id="username" type="text" placeholder="Enter your username" value={username} onChange={e => setUsername(e.target.value)} className={`flex h-10 w-full rounded-md border px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2196f3] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${isDarkMode ? 'bg-[#0d1117] border-gray-800 text-white' : 'bg-white border-gray-300 text-gray-900'}`} data-id="element-294" />
              </div>
              {/* Password Field */}
              <div className="space-y-2" data-id="element-295">
                <label htmlFor="password" className={`text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${isDarkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-296">
                  Password
                </label>
                <input id="password" type="password" placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} className={`flex h-10 w-full rounded-md border px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2196f3] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${isDarkMode ? 'bg-[#0d1117] border-gray-800 text-white' : 'bg-white border-gray-300 text-gray-900'}`} data-id="element-297" />
              </div>
              {/* Login Button */}
              <button type="submit" className="w-full inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2196f3] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-[#2196f3] text-white hover:bg-[#1976d2] h-10 px-4 py-2" data-id="element-298">
                Sign In
              </button>
            </form>
          </div>
        </div>
        {/* Footer */}
        <p className={`text-center text-sm mt-6 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-299">
          © 2024 BLAZE Lighthouse. All rights reserved.
        </p>
      </div>
    </div>;
};
export default LoginPage;